import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";
import type { Item } from "@/types/item";

export const useItems = () => {
	const {
		data: items,
		isLoading,
		error,
	} = useQuery({
		queryKey: ["items"],
		queryFn: async () => await api.get<Item[]>("/items"),
	});

	const createItemMutation = useMutation({
		mutationFn: (item: Omit<Item, "id">) => api.post<Item>("/item", item),
	});

	const updateItemMutation = useMutation({
		mutationFn: (item: Partial<Item>) =>
			api.put<Item>(`/item/${item.id}`, item),
	});

	const deleteItemMutation = useMutation({
		mutationFn: (id: string) => api.delete(`/item/${id}`),
	});

	return {
		items,
		createItemAsync: createItemMutation.mutateAsync,
		updateItem: updateItemMutation.mutateAsync,
		deleteItemAsync: deleteItemMutation.mutateAsync,
		isLoading,
		error,
	};
};
